import store from '@/store'
import storage from 'store'
import { ACCESS_TOKEN, USER_INFO, APP_LANGUAGE } from '@/store/mutation-types'

export default function Initializer () {
  store.commit('SET_TOKEN', storage.get(ACCESS_TOKEN))
	store.commit('SET_INFO', storage.get(USER_INFO))
  // store.dispatch('setLang', storage.get(APP_LANGUAGE, 'zh-CN'))
}
